'use client';

import MembershipCta, { MembershipCtaProps } from 'components/commercetools-ui/organisms/content/membership-cta';
import { TasticProps } from 'frontastic/tastics/types';

const MembershipCtaTastic = ({ data }: TasticProps<MembershipCtaProps>) => {
  return (
    <MembershipCta
      image={data.image}
      title={data.title}
      subtitle={data.subtitle}
      ctaLabel={data.ctaLabel}
      ctaReference={data.ctaReference}
      imageQuality={data.imageQuality}
      isPriority={data.isPriority}
    />
  );
};

export default MembershipCtaTastic;
